/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/14
 * Time: 11:26
 * Desc: 试穿及出样设置-试穿设置
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';

@Component
export default class TryOnSetting extends Vue {
  /* 数据 */

  /**
   * 试穿设置表单
   * @type {ItemObject}
   */
  public tryOnSettingForm: ItemObject = {
    bookingCount: 0, // 顾客一次可预约的数量
    bookingInterval: 0, // 顾客预约时间间隔(分钟)
    radius: 0, // 顾客离店多少米内可预约
    processIntro: '', // 顾客预约流程说明
  };

  /**
   * 数据效验（整数）
   * @type {Function}
   */
  public numberRule = (rule, value, callback) => {
    const reg = /^\d*$/;
    if (value === '') {
      callback(new Error('不能为空'));
    } else if (!reg.test(value)) {
      callback(new Error('请输入不小于0的整数'));
    } else {
      callback();
    }
  };

  /**
   * 试穿设置表单验证规则
   * @type {ItemObject}
   */
  public tryOnSettingFormRules: ItemObject = {
    bookingCount: [{ validator: this.numberRule, trigger: 'blur' }],
    bookingInterval: [{ validator: this.numberRule, trigger: 'blur' }],
    radius: [{ validator: this.numberRule, trigger: 'blur' }],
  };

  /* 方法 */

  /**
   * 获取集团顾客试穿和导购出样配置信息
   * @return null
   */
  public getGroupConfig(): void {
    IPSService.getGroupConfig({}).then((res) => {
      this.tryOnSettingForm.bookingCount = res.customerTryOnPerNum;
      this.tryOnSettingForm.bookingInterval = res.customerTryOnIntervalMinutes;
      this.tryOnSettingForm.radius = res.customerTryOnDistance;
      this.tryOnSettingForm.processIntro = res.customerTryOnDesc;
    });
  }

  /**
   * 保存集团顾客试穿和导购出样相关配置信息
   * @return null
   */
  public onSaveGroupConfig(): void {
    (this.$refs.tryOnSettingForm as any).validate((validate) => {
      // 去除两端多余的空格
      if (validate) {
        this.tryOnSettingForm.processIntro = this.tryOnSettingForm.processIntro ? this.tryOnSettingForm.processIntro.replace(/^\s+|\s+$/, '') : '';
        const postParams = {
          moduleType: 1, // 1：试穿设置，2：出样设置，3：其他设置
          customerTryOnPerNum: this.tryOnSettingForm.bookingCount,
          customerTryOnIntervalMinutes: this.tryOnSettingForm.bookingInterval,
          customerTryOnDistance: this.tryOnSettingForm.radius,
          customerTryOnDesc: this.tryOnSettingForm.processIntro,
        };
        IPSService.saveGroupConfig({ postParams }).then((res) => {
          if (res.ret) {
            this.$message.success('保存成功');
          } else {
            this.$message.error('保存失败');
          }
        });
      } else {
        return false;
      }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getGroupConfig(); // 获取集团顾客试穿和导购出样配置信息
  }
}
